module.exports = __webpack_public_path__ + "static/img/img_title_service.0a48580.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_service.png
// module id = 568
// module chunks = 1